import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import gridLabels from "../Labels/GridLabels";
import OSHMA_COLUMNS from "./OshmaTableColumn";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/loading";
import { getAllOshmas, updateOshma, deleteOshma } from "../../store/oshma";
import { Box } from "@mui/system";
import RowButtonIcon from "../UI/RowButtonIcon";
import EditIcon from "@mui/icons-material/Edit";
import BoxRowButtonsIcon from "../UI/BoxRowButtonsIcon";
import DialogDelete from "../UI/DialogDelete";
import SearchInput from "../UI/SearchInput";
import { DeleteOutline } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const OshmaTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    oshma,
    totalElements,
    totalPages,
    size,
    currentPage,
    searchValueCurrent,
  } = useSelector((state) => state.oshma);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [stateDialogDelete, setStateDialogDelete] = React.useState(false);
  const [isStatusNew, setIsStatusNew] = React.useState(false);
  const [oshmaState, setOshmaState] = React.useState({});
  const [dataColumns, setDataColumns] = React.useState(OSHMA_COLUMNS);
  const [page, setPage] = React.useState(currentPage);
  const searchState = React.useRef("");
  const [searchValueServer, setSearchValueServer] =
    React.useState(searchValueCurrent);

  const initialOshma = {
    id: "",
    name: "",
  };

  const handleChangePage = (event, newPage) => {
    setPage(event);
  };

  const searchItems = (e) => {
    const searchValue = e.target.value;
    if (searchValue !== "") {
      searchState.current.value = searchValue;
      let filterTimeout;
      filterTimeout = setTimeout(() => {
        setSearchValueServer(searchState.current.value);
      }, 1000);
    } else {
      setSearchValueServer("");
      dispatch(getAllOshmas({ page: page, searchValue: "" }));
    }
  };

  React.useEffect(() => {
    getAllData();
  }, [dispatch, page, searchValueServer]);

  const getAllData = () => {
    dispatch(setLoading(true));
    dispatch(getAllOshmas({ page: page, searchValue: searchValueServer }))
      .unwrap()
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };

  const [filterModel, setFilterModel] = React.useState({
    items: [
      {
        columnField: "",
        operatorValue: ">",
        value: "",
      },
    ],
  });

  const currentlySelected = (e) => {
    setIsStatusNew(false);
    setOshmaState(e.row);
    navigate("/oshmaProfile", { state: { oshmaData: e.row } });
    setOpen(true);
  };

  const handleCloseDialogDelete = (e) => {
    setStateDialogDelete(false);
  };

  const handleDeleteOshma = (e) => {
    dispatch(
      deleteOshma({
        id: oshmaState.id,
        page: page,
        searchValue: searchValueServer,
      })
    );
    setStateDialogDelete(false);
  };

  function CustomToolbar() {
    return (
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            py: "18px",
            px: "9px",
            alignItems: "center",
            bgcolor: "transparent",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              textAlign: "center",
              direction: "column",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <SearchInput
              onChange={searchItems}
              inputRef={searchState}
              defaultValue={searchState.current.value}
            ></SearchInput>
          </Box>
        </Box>
      </Box>
    );
  }
  return (
    <div style={{ height: 700, width: "100%" }}>
      <DataGrid
        labelRowsPerPage="Artikuj per faqe"
        disableSelectionOnClick
        onRowDoubleClick={currentlySelected}
        columns={[
          ...dataColumns,
          {
            headerName: "",
            overflow: "hidden",
            field: "actions",
            editable: false,
            flex: 1,
            justifyContent: "flex-end",
            disableClickEventBubbling: true,
            align: "right",
            background: "red",
            headers: false,
            renderHeader: () => {},
            renderCell: (params) => (
              <BoxRowButtonsIcon>
                <RowButtonIcon
                  onClick={(event) => {
                    currentlySelected(params);
                  }}
                >
                  <EditIcon />
                </RowButtonIcon>
                <RowButtonIcon
                  onClick={(event) => {
                    // currentlySelected(params);
                    setOshmaState(params?.row);
                    setStateDialogDelete(true);
                  }}
                >
                  <DeleteOutline color="error" />
                </RowButtonIcon>
              </BoxRowButtonsIcon>
            ),
          },
        ]}
        rows={oshma ? oshma : []}
        density="comfortable"
        editMode="row"
        disableColumnMenu
        localeText={gridLabels}
        componentsProps={{
          pagination: {
            labelRowsPerPage: "Rreshta për Faqe",
            showLastButton: true,
            showFirstButton: true,
          },
        }}
        components={{
          Toolbar: CustomToolbar,
        }}
        // onCellClick={currentlySelected}
        filterModel={filterModel}
        onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
        page={page}
        onPageChange={handleChangePage}
        count={totalPages}
        rowCount={totalElements}
        pageSize={size > 100 ? 100 : size}
        pagination
        paginationMode="server"
      />
      <DialogDelete
        open={stateDialogDelete}
        disagreedelete={handleCloseDialogDelete}
        agreedelete={handleDeleteOshma}
        description="Jeni të sigurt që doni ta fshini këtë OSHMA? "
      />
    </div>
  );
};

export default OshmaTable;
